// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1gXLS","location":"Header_location__2GF11"};